export class TablaHtml{
    id!:string;
    descripcion:string = '';
    estiloClase!:string;
    isEvento:boolean = false;
    hijosHtml:Array<TablaHtml>=new Array();
}